import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoginComponent } from "./login/login.component";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [CommonModule, FormsModule, RouterModule],
  declarations: [LoginComponent],
  exports: [LoginComponent],
})
export class AuthorizationModule {}
